import { useState, useEffect } from "react";
import { message } from "antd";
import API from "../../../../services/API";

export default function useMerchantActivation({ userId }) {
    const [isEnrolled, setIsEnrolled] = useState(false);
    const [merchantsList, setMerchantsList] = useState([]);
    const [deletedMerchants, setDeletedMerchants] = useState([]);
    const [merchantToAddList, setMerchantToAddList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalSpendLimit, setTotalSpendLimit] = useState(0);
    const [availableSpendLimit, setAllocatedSpendLimit] = useState(0);
    const [minSpendLimit, setMinSpendLimit] = useState(0);

    useEffect(() => {
        getMerchantActivation();
    }, [userId]);

    const getMerchantActivation = async () => {
        try {
            // enrolled boolean
            const res = await API.getMerchantActivationV3Experience({ userId });
            setIsEnrolled(res?.enrolled || false);

            if (res?.enrolled) {
                // merchants list
                const merchantsList = await API.getMerchantActivationMerchantsList({ userId });
                setMerchantsList(merchantsList.activatedMerchants);
                // merchant to add list
                const merchantToAddList = await API.getMerchantActivationMerchantToAddList({ userId });
                const mergedById = new Map();
                [ // merge the allowed merchants and the deleted merchants by id
                    ...(merchantToAddList.allowedMerchants || []),
                    ...(merchantsList?.deletedMerchants?.map(merchant => ({ ...merchant, id: merchant.merchantId, isDeleted: true })) || [])
                ].forEach((merchant) => {
                    mergedById.set(merchant.id, { ...(mergedById.get(merchant.id) || {}), ...merchant });
                });
                const merchantsToAddWithDeleted = [...mergedById.values()];
                setMerchantToAddList(merchantsToAddWithDeleted);
                // total spend limit
                setTotalSpendLimit(merchantToAddList.totalSpendLimitInCents);
                // allocated spend limit
                setAllocatedSpendLimit(merchantToAddList.availableSpendLimitInCents);
                setMinSpendLimit(merchantToAddList.minSpendLimitInCents || 0);
                // deleted merchants
                setDeletedMerchants(merchantsList?.deletedMerchants || []);
            }
        } catch (error) {
            console.error(error);
        }
    }

    const deleteMerchant = async (merchant) => {
        if (window.confirm(`Are you sure you want to delete ${merchant.displayName}?`)) {
            try {
                setLoading(true);
                await API.deleteMerchantActivationMerchant({ userId, merchantName: merchant.merchantGroupName });
                getMerchantActivation();
            } catch (error) {
                message.error('Failed to delete merchant.');
                console.error(error);
            } finally {
                setLoading(false);
            }
        }
    }

    return {
        isEnrolled,
        merchantsList,
        deletedMerchants,
        merchantToAddList,
        totalSpendLimit,
        availableSpendLimit,
        minSpendLimit,
        loading,
        deleteMerchant,
        getMerchantActivation
    };
}